import { render } from "./video-instruction.vue?vue&type=template&id=b542738c&scoped=true"
import script from "./video-instruction.vue?vue&type=script&lang=js"
export * from "./video-instruction.vue?vue&type=script&lang=js"

import "./video-instruction.vue?vue&type=style&index=0&id=b542738c&scoped=true&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b542738c"]])

export default __exports__